import React, { useEffect, useState } from "react";
import LoaderBigTwo from "../../Shared/LoaderBigTwo/LoaderBigTwo";
import './Refunds.css'
import { Link } from "react-router-dom";

const RefundRequest = () => {
  const [RefundRequest, setRefundRequest] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRefundRequest = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/refundsMainData");
      const data = await response.json();
      setRefundRequest(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchRefundRequest();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 16; // Set the number of items to display per page
  const maxPageButtons = 5; // Set the maximum number of pagination buttons to display

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = RefundRequest.slice(indexOfFirstItem, indexOfLastItem);

  const totalPageCount = Math.ceil(RefundRequest.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const generatePaginationButtons = () => {
    const pageButtons = [];
    let startPage = 1;
    let endPage = totalPageCount;

    if (totalPageCount > maxPageButtons) {
      if (currentPage <= Math.ceil(maxPageButtons / 2)) {
        endPage = maxPageButtons;
      } else if (
        currentPage >
        totalPageCount - Math.floor(maxPageButtons / 2)
      ) {
        startPage = totalPageCount - maxPageButtons + 1;
      } else {
        startPage = currentPage - Math.floor(maxPageButtons / 2);
        endPage = currentPage + Math.floor(maxPageButtons / 2);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <li key={i}>
          <button
            onClick={() => handlePageChange(i)}
            className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
              currentPage === i ? "text-blue-600 bg-blue-50" : ""
            }`}
          >
            {i}
          </button>
        </li>
      );
    }

    return pageButtons;
  };


  
  return (
    <div>
      {loading ? (
        <div className="flex justify-center items-center ">
          <LoaderBigTwo></LoaderBigTwo>
        </div>
      ) : (
        <div>
          <div>
            {currentItems.map((refund, index) => (
              <Link to={`/dashboardTwo/RequestRefundDetails/${refund._id}`}>
              <div className="w-full px-5 flex flex-row justify-between items-center h-48 border-2 rounded-lg border-gray-200 hover:border-orange-500 focus:border-orange-500">
                <div>
                    <h1 className="refundReqText py-2">Request Number : <span className="RefundTextTwo"></span>{index + 1}</h1>
                    <h1 className="refundReqText py-2">Name : <span className="RefundTextTwo"></span>{refund.teacherName}</h1>
                    <h1 className="refundReqText py-2">Number : <span className="RefundTextTwo"></span>{refund.teacherPhone}</h1>
                    <h1 className="refundReqText py-2">Request Date: <span className="RefundTextTwo"></span>{new Date(refund.refundDate).toLocaleDateString("en-GB")}</h1>
                  
                </div>
                <div className="flex justify-center items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="30"
                    viewBox="0 0 60 30"
                    fill="none"
                  >
                    <path
                      d="M59.3104 14.0435L45.7414 0.474325C45.254 -0.0948453 44.3974 -0.161196 43.8282 0.326348C43.259 0.813775 43.1927 1.67039 43.6802 2.23956C43.7257 2.29261 43.7751 2.34217 43.8282 2.38753L55.0769 13.6499H1.35687C0.607535 13.6499 0 14.2574 0 15.0069C0 15.7563 0.607535 16.3637 1.35687 16.3637H55.0769L43.8282 27.6125C43.259 28.0999 43.1927 28.9565 43.6802 29.5257C44.1678 30.0948 45.0243 30.1612 45.5934 29.6737C45.6465 29.6282 45.696 29.5787 45.7414 29.5257L59.3105 15.9565C59.8366 15.4275 59.8366 14.5727 59.3104 14.0435Z"
                      fill="#0289FD"
                    />
                  </svg>
                </div>
              </div>
              </Link>
            ))}
          </div>
          <div className="flex items-center justify-center mt-10">
            <nav aria-label="Page navigation example">
              <ul className="inline-flex -space-x-px text-sm">
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    className={`flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                      currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    Previous
                  </button>
                </li>
                {generatePaginationButtons()}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover-bg-gray-100 hover-text-gray-700 dark-bg-gray-800 dark-border-gray-700 dark-text-gray-400 dark-hover-bg-gray-700 dark-hover-text-white ${
                      currentPage === totalPageCount
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )}
    </div>
  );
};

export default RefundRequest;
